export default __webpack_public_path__ + "static/media/dk.21802a48.svg";